module.exports = __webpack_public_path__ + "img/lasprovincias.6b577709.svg";